import { AdLoadingStrategyTypeEnum, AdSizes, AdUnit, AdUnitSpecialUseCaseEnum, AdUnitTypeEnum } from "@repo/lib-domain-tag";
import { pageBidderHelper } from "../pageBidderHelper";
import { deviceUtil } from "@repo/lib-common";
export const desktopIntextAdUnits = [

    //#region intext index 1
    AdUnit.builder(AdUnitTypeEnum.banner)
        .setDeviceType(deviceUtil.DeviceTypeInfo.desktopDevices)
        .setSpecialUseCase(AdUnitSpecialUseCaseEnum.intext)
        .setSpecialUseCaseIndex(1)
        .setIsEnabled(true)
        .setAdUnitPath("/66738120/sozcu_body_intext_300x250_first")
        .setDivId("div-sozcu_body_intext_300x250_1")
        .setDivStyleAfterRequest('')
        .setLoadingStrategy(AdLoadingStrategyTypeEnum.trigger)
        .setSizes(AdSizes.desktop_Intext)
        .setIsAutoRefreshEnabled(true)
        .setIsPrebidEnabled(true)
        .setPrebidSizeLimits(AdSizes.prebid_300x250)
        .setBidderHelper(pageBidderHelper)

    ,

    //#endregion

    //#region intext index 2
    AdUnit.builder(AdUnitTypeEnum.banner)
        .setDeviceType(deviceUtil.DeviceTypeInfo.desktopDevices)
        .setSpecialUseCase(AdUnitSpecialUseCaseEnum.intext)
        .setSpecialUseCaseIndex(2)
        .setIsEnabled(true)
        .setAdUnitPath("/66738120/sozcu_body_intext_300x250")
        .setDivId("div-sozcu_body_intext_300x250_2")
        .setDivStyleAfterRequest('')
        .setLoadingStrategy(AdLoadingStrategyTypeEnum.trigger)
        .setSizes(AdSizes.desktop_Intext)
        .setIsAutoRefreshEnabled(true)
        .setIsPrebidEnabled(true)
        .setPrebidSizeLimits(AdSizes.prebid_300x250)
        .setBidderHelper(pageBidderHelper)

    ,
    AdUnit.builder(AdUnitTypeEnum.banner)
        .setDeviceType(deviceUtil.DeviceTypeInfo.desktopDevices)
        .setSpecialUseCase(AdUnitSpecialUseCaseEnum.intext)
        .setSpecialUseCaseIndex(2)
        .setIsEnabled(true)
        .setAdUnitPath("/66738120/sozcu_body_intext_300x250")
        .setDivId("div-sozcu_body_intext_300x250_3")
        .setDivStyleAfterRequest('')
        .setLoadingStrategy(AdLoadingStrategyTypeEnum.trigger)
        .setSizes(AdSizes.desktop_Intext)
        .setIsAutoRefreshEnabled(true)
        .setIsPrebidEnabled(true)
        .setPrebidSizeLimits(AdSizes.prebid_300x250)
        .setBidderHelper(pageBidderHelper)

    ,
    //#endregion

    //#region intext index 3
    AdUnit.builder(AdUnitTypeEnum.banner)
        .setDeviceType(deviceUtil.DeviceTypeInfo.desktopDevices)
        .setSpecialUseCase(AdUnitSpecialUseCaseEnum.intext)
        .setSpecialUseCaseIndex(3)
        .setIsEnabled(true)
        .setAdUnitPath("/66738120/sozcu_body_intext_300x250")
        .setDivId("div-sozcu_body_intext_300x250_4")
        .setDivStyleAfterRequest('')
        .setLoadingStrategy(AdLoadingStrategyTypeEnum.trigger)
        .setSizes(AdSizes.desktop_Intext)
        .setIsAutoRefreshEnabled(true)
        .setIsPrebidEnabled(true)
        .setPrebidSizeLimits(AdSizes.prebid_300x250)
        .setBidderHelper(pageBidderHelper)

    ,
    AdUnit.builder(AdUnitTypeEnum.banner)
        .setDeviceType(deviceUtil.DeviceTypeInfo.desktopDevices)
        .setSpecialUseCase(AdUnitSpecialUseCaseEnum.intext)
        .setSpecialUseCaseIndex(3)
        .setIsEnabled(true)
        .setAdUnitPath("/66738120/sozcu_body_intext_300x250")
        .setDivId("div-sozcu_body_intext_300x250_5")
        .setDivStyleAfterRequest('')
        .setLoadingStrategy(AdLoadingStrategyTypeEnum.trigger)
        .setSizes(AdSizes.desktop_Intext)
        .setIsAutoRefreshEnabled(true)
        .setIsPrebidEnabled(true)
        .setPrebidSizeLimits(AdSizes.prebid_300x250)
        .setBidderHelper(pageBidderHelper)

    ,
    //#endregion

    //#region intext index 4
    AdUnit.builder(AdUnitTypeEnum.banner)
        .setDeviceType(deviceUtil.DeviceTypeInfo.desktopDevices)
        .setSpecialUseCase(AdUnitSpecialUseCaseEnum.intext)
        .setSpecialUseCaseIndex(4)
        .setIsEnabled(true)
        .setAdUnitPath("/66738120/sozcu_body_intext_300x250")
        .setDivId("div-sozcu_body_intext_300x250_6")
        .setDivStyleAfterRequest('')
        .setLoadingStrategy(AdLoadingStrategyTypeEnum.trigger)
        .setSizes(AdSizes.desktop_Intext)
        .setIsAutoRefreshEnabled(true)
        .setIsPrebidEnabled(true)
        .setPrebidSizeLimits(AdSizes.prebid_300x250)
        .setBidderHelper(pageBidderHelper)

    ,
    AdUnit.builder(AdUnitTypeEnum.banner)
        .setDeviceType(deviceUtil.DeviceTypeInfo.desktopDevices)
        .setSpecialUseCase(AdUnitSpecialUseCaseEnum.intext)
        .setSpecialUseCaseIndex(4)
        .setIsEnabled(true)
        .setAdUnitPath("/66738120/sozcu_body_intext_300x250")
        .setDivId("div-sozcu_body_intext_300x250_7")
        .setDivStyleAfterRequest('')
        .setLoadingStrategy(AdLoadingStrategyTypeEnum.trigger)
        .setSizes(AdSizes.desktop_Intext)
        .setIsAutoRefreshEnabled(true)
        .setIsPrebidEnabled(true)
        .setPrebidSizeLimits(AdSizes.prebid_300x250)
        .setBidderHelper(pageBidderHelper)

    ,
    //#endregion

    //#region intext index 5
    AdUnit.builder(AdUnitTypeEnum.banner)
        .setDeviceType(deviceUtil.DeviceTypeInfo.desktopDevices)
        .setSpecialUseCase(AdUnitSpecialUseCaseEnum.intext)
        .setSpecialUseCaseIndex(5)
        .setIsEnabled(true)
        .setAdUnitPath("/66738120/sozcu_body_intext_300x250")
        .setDivId("div-sozcu_body_intext_300x250_8")
        .setDivStyleAfterRequest('')
        .setLoadingStrategy(AdLoadingStrategyTypeEnum.trigger)
        .setSizes(AdSizes.desktop_Intext)
        .setIsAutoRefreshEnabled(true)
        .setIsPrebidEnabled(true)
        .setPrebidSizeLimits(AdSizes.prebid_300x250)
        .setBidderHelper(pageBidderHelper)

    ,
    AdUnit.builder(AdUnitTypeEnum.banner)
        .setDeviceType(deviceUtil.DeviceTypeInfo.desktopDevices)
        .setSpecialUseCase(AdUnitSpecialUseCaseEnum.intext)
        .setSpecialUseCaseIndex(5)
        .setIsEnabled(true)
        .setAdUnitPath("/66738120/sozcu_body_intext_300x250")
        .setDivId("div-sozcu_body_intext_300x250_9")
        .setDivStyleAfterRequest('')
        .setLoadingStrategy(AdLoadingStrategyTypeEnum.trigger)
        .setSizes(AdSizes.desktop_Intext)
        .setIsAutoRefreshEnabled(true)
        .setIsPrebidEnabled(true)
        .setPrebidSizeLimits(AdSizes.prebid_300x250)
        .setBidderHelper(pageBidderHelper)

    ,
    //#endregion

    //#region intext index 6
    AdUnit.builder(AdUnitTypeEnum.banner)
        .setDeviceType(deviceUtil.DeviceTypeInfo.desktopDevices)
        .setSpecialUseCase(AdUnitSpecialUseCaseEnum.intext)
        .setSpecialUseCaseIndex(6)
        .setIsEnabled(true)
        .setAdUnitPath("/66738120/sozcu_body_intext_300x250")
        .setDivId("div-sozcu_body_intext_300x250_10")
        .setDivStyleAfterRequest('')
        .setLoadingStrategy(AdLoadingStrategyTypeEnum.trigger)
        .setSizes(AdSizes.desktop_Intext)
        .setIsAutoRefreshEnabled(true)
        .setIsPrebidEnabled(true)
        .setPrebidSizeLimits(AdSizes.prebid_300x250)
        .setBidderHelper(pageBidderHelper)

    ,
    AdUnit.builder(AdUnitTypeEnum.banner)
        .setDeviceType(deviceUtil.DeviceTypeInfo.desktopDevices)
        .setSpecialUseCase(AdUnitSpecialUseCaseEnum.intext)
        .setSpecialUseCaseIndex(6)
        .setIsEnabled(true)
        .setAdUnitPath("/66738120/sozcu_body_intext_300x250")
        .setDivId("div-sozcu_body_intext_300x250_11")
        .setDivStyleAfterRequest('')
        .setLoadingStrategy(AdLoadingStrategyTypeEnum.trigger)
        .setSizes(AdSizes.desktop_Intext)
        .setIsAutoRefreshEnabled(true)
        .setIsPrebidEnabled(true)
        .setPrebidSizeLimits(AdSizes.prebid_300x250)
        .setBidderHelper(pageBidderHelper)

    ,
    //#endregion

    //#region intext index 7
    AdUnit.builder(AdUnitTypeEnum.banner)
        .setDeviceType(deviceUtil.DeviceTypeInfo.desktopDevices)
        .setSpecialUseCase(AdUnitSpecialUseCaseEnum.intext)
        .setSpecialUseCaseIndex(7)
        .setIsEnabled(true)
        .setAdUnitPath("/66738120/sozcu_body_intext_300x250")
        .setDivId("div-sozcu_body_intext_300x250_12")
        .setDivStyleAfterRequest('')
        .setLoadingStrategy(AdLoadingStrategyTypeEnum.trigger)
        .setSizes(AdSizes.desktop_Intext)
        .setIsAutoRefreshEnabled(true)
        .setIsPrebidEnabled(true)
        .setPrebidSizeLimits(AdSizes.prebid_300x250)
        .setBidderHelper(pageBidderHelper)

    ,
    AdUnit.builder(AdUnitTypeEnum.banner)
        .setDeviceType(deviceUtil.DeviceTypeInfo.desktopDevices)
        .setSpecialUseCase(AdUnitSpecialUseCaseEnum.intext)
        .setSpecialUseCaseIndex(7)
        .setIsEnabled(true)
        .setAdUnitPath("/66738120/sozcu_body_intext_300x250")
        .setDivId("div-sozcu_body_intext_300x250_13")
        .setDivStyleAfterRequest('')
        .setLoadingStrategy(AdLoadingStrategyTypeEnum.trigger)
        .setSizes(AdSizes.desktop_Intext)
        .setIsAutoRefreshEnabled(true)
        .setIsPrebidEnabled(true)
        .setPrebidSizeLimits(AdSizes.prebid_300x250)
        .setBidderHelper(pageBidderHelper)

    ,
    //#endregion

    //#region intext index 8
    AdUnit.builder(AdUnitTypeEnum.banner)
        .setDeviceType(deviceUtil.DeviceTypeInfo.desktopDevices)
        .setSpecialUseCase(AdUnitSpecialUseCaseEnum.intext)
        .setSpecialUseCaseIndex(8)
        .setIsEnabled(true)
        .setAdUnitPath("/66738120/sozcu_body_intext_300x250")
        .setDivId("div-sozcu_body_intext_300x250_14")
        .setDivStyleAfterRequest('')
        .setLoadingStrategy(AdLoadingStrategyTypeEnum.trigger)
        .setSizes(AdSizes.desktop_Intext)
        .setIsAutoRefreshEnabled(true)
        .setIsPrebidEnabled(true)
        .setPrebidSizeLimits(AdSizes.prebid_300x250)
        .setBidderHelper(pageBidderHelper)

    ,
    AdUnit.builder(AdUnitTypeEnum.banner)
        .setDeviceType(deviceUtil.DeviceTypeInfo.desktopDevices)
        .setSpecialUseCase(AdUnitSpecialUseCaseEnum.intext)
        .setSpecialUseCaseIndex(8)
        .setIsEnabled(true)
        .setAdUnitPath("/66738120/sozcu_body_intext_300x250")
        .setDivId("div-sozcu_body_intext_300x250_15")
        .setDivStyleAfterRequest('')
        .setLoadingStrategy(AdLoadingStrategyTypeEnum.trigger)
        .setSizes(AdSizes.desktop_Intext)
        .setIsAutoRefreshEnabled(true)
        .setIsPrebidEnabled(true)
        .setPrebidSizeLimits(AdSizes.prebid_300x250)
        .setBidderHelper(pageBidderHelper)

    ,
    //#endregion

    //#region intext index 9
    AdUnit.builder(AdUnitTypeEnum.banner)
        .setDeviceType(deviceUtil.DeviceTypeInfo.desktopDevices)
        .setSpecialUseCase(AdUnitSpecialUseCaseEnum.intext)
        .setSpecialUseCaseIndex(9)
        .setIsEnabled(true)
        .setAdUnitPath("/66738120/sozcu_body_intext_300x250")
        .setDivId("div-sozcu_body_intext_300x250_16")
        .setDivStyleAfterRequest('')
        .setLoadingStrategy(AdLoadingStrategyTypeEnum.trigger)
        .setSizes(AdSizes.desktop_Intext)
        .setIsAutoRefreshEnabled(true)
        .setIsPrebidEnabled(true)
        .setPrebidSizeLimits(AdSizes.prebid_300x250)
        .setBidderHelper(pageBidderHelper)

    ,
    AdUnit.builder(AdUnitTypeEnum.banner)
        .setDeviceType(deviceUtil.DeviceTypeInfo.desktopDevices)
        .setSpecialUseCase(AdUnitSpecialUseCaseEnum.intext)
        .setSpecialUseCaseIndex(9)
        .setIsEnabled(true)
        .setAdUnitPath("/66738120/sozcu_body_intext_300x250")
        .setDivId("div-sozcu_body_intext_300x250_17")
        .setDivStyleAfterRequest('')
        .setLoadingStrategy(AdLoadingStrategyTypeEnum.trigger)
        .setSizes(AdSizes.desktop_Intext)
        .setIsAutoRefreshEnabled(true)
        .setIsPrebidEnabled(true)
        .setPrebidSizeLimits(AdSizes.prebid_300x250)
        .setBidderHelper(pageBidderHelper)

    ,
    //#endregion

    //#region intext index 10
    AdUnit.builder(AdUnitTypeEnum.banner)
        .setDeviceType(deviceUtil.DeviceTypeInfo.desktopDevices)
        .setSpecialUseCase(AdUnitSpecialUseCaseEnum.intext)
        .setSpecialUseCaseIndex(10)
        .setIsEnabled(true)
        .setAdUnitPath("/66738120/sozcu_body_intext_300x250")
        .setDivId("div-sozcu_body_intext_300x250_18")
        .setDivStyleAfterRequest('')
        .setLoadingStrategy(AdLoadingStrategyTypeEnum.trigger)
        .setSizes(AdSizes.desktop_Intext)
        .setIsAutoRefreshEnabled(true)
        .setIsPrebidEnabled(true)
        .setPrebidSizeLimits(AdSizes.prebid_300x250)
        .setBidderHelper(pageBidderHelper)

    ,
    AdUnit.builder(AdUnitTypeEnum.banner)
        .setDeviceType(deviceUtil.DeviceTypeInfo.desktopDevices)
        .setSpecialUseCase(AdUnitSpecialUseCaseEnum.intext)
        .setSpecialUseCaseIndex(10)
        .setIsEnabled(true)
        .setAdUnitPath("/66738120/sozcu_body_intext_300x250")
        .setDivId("div-sozcu_body_intext_300x250_19")
        .setDivStyleAfterRequest('')
        .setLoadingStrategy(AdLoadingStrategyTypeEnum.trigger)
        .setSizes(AdSizes.desktop_Intext)
        .setIsAutoRefreshEnabled(true)
        .setIsPrebidEnabled(true)
        .setPrebidSizeLimits(AdSizes.prebid_300x250)
        .setBidderHelper(pageBidderHelper)

    ,
    //#endregion



]


export const mobileIntextAdUnits = [
    //#region intext index 1

    AdUnit.builder(AdUnitTypeEnum.banner)
        .setDeviceType(deviceUtil.DeviceTypeInfo.mobileDevices)
        .setSpecialUseCase(AdUnitSpecialUseCaseEnum.intext)
        .setSpecialUseCaseIndex(1)
        .setIsEnabled(true)
        .setAdUnitPath("/66738120/sozcu_body_intext_mobile_first")
        .setDivId("div-sozcu_m_body_intext_300x250_1")
        .setDivStyleAfterRequest('')
        .setLoadingStrategy(AdLoadingStrategyTypeEnum.trigger)
        .setSizes(AdSizes.mobile_Generic)
        .setIsAutoRefreshEnabled(true)
        .setIsPrebidEnabled(true)
        .setPrebidSizeLimits(AdSizes.prebid_300x250)
        .setBidderHelper(pageBidderHelper)
    //.onSlotRenderEnded(fixPageSkinCssClass)

    ,

    //#endregion

    //#region intext index 2
    AdUnit.builder(AdUnitTypeEnum.banner)
        .setDeviceType(deviceUtil.DeviceTypeInfo.mobileDevices)
        .setSpecialUseCase(AdUnitSpecialUseCaseEnum.intext)
        .setSpecialUseCaseIndex(2)
        .setIsEnabled(true)
        .setAdUnitPath("/66738120/sozcu_body_intext_mobile")
        .setDivId("div-sozcu_m_body_intext_300x250_2")
        .setDivStyleAfterRequest('')
        .setLoadingStrategy(AdLoadingStrategyTypeEnum.trigger)
        .setSizes(AdSizes.mobile_Generic)
        .setIsAutoRefreshEnabled(true)
        .setIsPrebidEnabled(true)
        .setPrebidSizeLimits(AdSizes.prebid_300x250)
        .setBidderHelper(pageBidderHelper)
    //.onSlotRenderEnded(fixPageSkinCssClass)

    ,
    AdUnit.builder(AdUnitTypeEnum.banner)
        .setDeviceType(deviceUtil.DeviceTypeInfo.mobileDevices)
        .setSpecialUseCase(AdUnitSpecialUseCaseEnum.intext)
        .setSpecialUseCaseIndex(2)
        .setIsEnabled(true)
        .setAdUnitPath("/66738120/sozcu_body_intext_mobile")
        .setDivId("div-sozcu_m_body_intext_300x250_3")
        .setDivStyleAfterRequest('')
        .setLoadingStrategy(AdLoadingStrategyTypeEnum.trigger)
        .setSizes(AdSizes.mobile_Generic)
        .setIsAutoRefreshEnabled(true)
        .setIsPrebidEnabled(true)
        .setPrebidSizeLimits(AdSizes.prebid_300x250)
        .setBidderHelper(pageBidderHelper)
    //.onSlotRenderEnded(fixPageSkinCssClass)

    ,
    //#endregion

    //#region intext index 3
    AdUnit.builder(AdUnitTypeEnum.banner)
        .setDeviceType(deviceUtil.DeviceTypeInfo.mobileDevices)
        .setSpecialUseCase(AdUnitSpecialUseCaseEnum.intext)
        .setSpecialUseCaseIndex(3)
        .setIsEnabled(true)
        .setAdUnitPath("/66738120/sozcu_body_intext_mobile")
        .setDivId("div-sozcu_m_body_intext_300x250_4")
        .setDivStyleAfterRequest('')
        .setLoadingStrategy(AdLoadingStrategyTypeEnum.trigger)
        .setSizes(AdSizes.mobile_Generic)
        .setIsAutoRefreshEnabled(true)
        .setIsPrebidEnabled(true)
        .setPrebidSizeLimits(AdSizes.prebid_300x250)
        .setBidderHelper(pageBidderHelper)
    //.onSlotRenderEnded(fixPageSkinCssClass)

    ,
    AdUnit.builder(AdUnitTypeEnum.banner)
        .setDeviceType(deviceUtil.DeviceTypeInfo.mobileDevices)
        .setSpecialUseCase(AdUnitSpecialUseCaseEnum.intext)
        .setSpecialUseCaseIndex(3)
        .setIsEnabled(true)
        .setAdUnitPath("/66738120/sozcu_body_intext_mobile")
        .setDivId("div-sozcu_m_body_intext_300x250_5")
        .setDivStyleAfterRequest('')
        .setLoadingStrategy(AdLoadingStrategyTypeEnum.trigger)
        .setSizes(AdSizes.mobile_Generic)
        .setIsAutoRefreshEnabled(true)
        .setIsPrebidEnabled(true)
        .setPrebidSizeLimits(AdSizes.prebid_300x250)
        .setBidderHelper(pageBidderHelper)
    //.onSlotRenderEnded(fixPageSkinCssClass)

    ,
    //#endregion

    //#region intext index 4
    AdUnit.builder(AdUnitTypeEnum.banner)
        .setDeviceType(deviceUtil.DeviceTypeInfo.mobileDevices)
        .setSpecialUseCase(AdUnitSpecialUseCaseEnum.intext)
        .setSpecialUseCaseIndex(4)
        .setIsEnabled(true)
        .setAdUnitPath("/66738120/sozcu_body_intext_mobile")
        .setDivId("div-sozcu_m_body_intext_300x250_6")
        .setDivStyleAfterRequest('')
        .setLoadingStrategy(AdLoadingStrategyTypeEnum.trigger)
        .setSizes(AdSizes.mobile_Generic)
        .setIsAutoRefreshEnabled(true)
        .setIsPrebidEnabled(true)
        .setPrebidSizeLimits(AdSizes.prebid_300x250)
        .setBidderHelper(pageBidderHelper)
    //.onSlotRenderEnded(fixPageSkinCssClass)

    ,
    AdUnit.builder(AdUnitTypeEnum.banner)
        .setDeviceType(deviceUtil.DeviceTypeInfo.mobileDevices)
        .setSpecialUseCase(AdUnitSpecialUseCaseEnum.intext)
        .setSpecialUseCaseIndex(4)
        .setIsEnabled(true)
        .setAdUnitPath("/66738120/sozcu_body_intext_mobile")
        .setDivId("div-sozcu_m_body_intext_300x250_7")
        .setDivStyleAfterRequest('')
        .setLoadingStrategy(AdLoadingStrategyTypeEnum.trigger)
        .setSizes(AdSizes.mobile_Generic)
        .setIsAutoRefreshEnabled(true)
        .setIsPrebidEnabled(true)
        .setPrebidSizeLimits(AdSizes.prebid_300x250)
        .setBidderHelper(pageBidderHelper)
    //.onSlotRenderEnded(fixPageSkinCssClass)

    ,
    //#endregion

    //#region intext index 5
    AdUnit.builder(AdUnitTypeEnum.banner)
        .setDeviceType(deviceUtil.DeviceTypeInfo.mobileDevices)
        .setSpecialUseCase(AdUnitSpecialUseCaseEnum.intext)
        .setSpecialUseCaseIndex(5)
        .setIsEnabled(true)
        .setAdUnitPath("/66738120/sozcu_body_intext_mobile")
        .setDivId("div-sozcu_m_body_intext_300x250_8")
        .setDivStyleAfterRequest('')
        .setLoadingStrategy(AdLoadingStrategyTypeEnum.trigger)
        .setSizes(AdSizes.mobile_Generic)
        .setIsAutoRefreshEnabled(true)
        .setIsPrebidEnabled(true)
        .setPrebidSizeLimits(AdSizes.prebid_300x250)
        .setBidderHelper(pageBidderHelper)
    //.onSlotRenderEnded(fixPageSkinCssClass)

    ,
    AdUnit.builder(AdUnitTypeEnum.banner)
        .setDeviceType(deviceUtil.DeviceTypeInfo.mobileDevices)
        .setSpecialUseCase(AdUnitSpecialUseCaseEnum.intext)
        .setSpecialUseCaseIndex(5)
        .setIsEnabled(true)
        .setAdUnitPath("/66738120/sozcu_body_intext_mobile")
        .setDivId("div-sozcu_m_body_intext_300x250_9")
        .setDivStyleAfterRequest('')
        .setLoadingStrategy(AdLoadingStrategyTypeEnum.trigger)
        .setSizes(AdSizes.mobile_Generic)
        .setIsAutoRefreshEnabled(true)
        .setIsPrebidEnabled(true)
        .setPrebidSizeLimits(AdSizes.prebid_300x250)
        .setBidderHelper(pageBidderHelper)
    //.onSlotRenderEnded(fixPageSkinCssClass)

    ,
    //#endregion

    //#region intext index 6
    AdUnit.builder(AdUnitTypeEnum.banner)
        .setDeviceType(deviceUtil.DeviceTypeInfo.mobileDevices)
        .setSpecialUseCase(AdUnitSpecialUseCaseEnum.intext)
        .setSpecialUseCaseIndex(6)
        .setIsEnabled(true)
        .setAdUnitPath("/66738120/sozcu_body_intext_mobile")
        .setDivId("div-sozcu_m_body_intext_300x250_10")
        .setDivStyleAfterRequest('')
        .setLoadingStrategy(AdLoadingStrategyTypeEnum.trigger)
        .setSizes(AdSizes.mobile_Generic)
        .setIsAutoRefreshEnabled(true)
        .setIsPrebidEnabled(true)
        .setPrebidSizeLimits(AdSizes.prebid_300x250)
        .setBidderHelper(pageBidderHelper)
    //.onSlotRenderEnded(fixPageSkinCssClass)

    ,
    AdUnit.builder(AdUnitTypeEnum.banner)
        .setDeviceType(deviceUtil.DeviceTypeInfo.mobileDevices)
        .setSpecialUseCase(AdUnitSpecialUseCaseEnum.intext)
        .setSpecialUseCaseIndex(6)
        .setIsEnabled(true)
        .setAdUnitPath("/66738120/sozcu_body_intext_mobile")
        .setDivId("div-sozcu_m_body_intext_300x250_11")
        .setDivStyleAfterRequest('')
        .setLoadingStrategy(AdLoadingStrategyTypeEnum.trigger)
        .setSizes(AdSizes.mobile_Generic)
        .setIsAutoRefreshEnabled(true)
        .setIsPrebidEnabled(true)
        .setPrebidSizeLimits(AdSizes.prebid_300x250)
        .setBidderHelper(pageBidderHelper)
    //.onSlotRenderEnded(fixPageSkinCssClass)

    ,
    //#endregion

    //#region intext index 7
    AdUnit.builder(AdUnitTypeEnum.banner)
        .setDeviceType(deviceUtil.DeviceTypeInfo.mobileDevices)
        .setSpecialUseCase(AdUnitSpecialUseCaseEnum.intext)
        .setSpecialUseCaseIndex(7)
        .setIsEnabled(true)
        .setAdUnitPath("/66738120/sozcu_body_intext_mobile")
        .setDivId("div-sozcu_m_body_intext_300x250_12")
        .setDivStyleAfterRequest('')
        .setLoadingStrategy(AdLoadingStrategyTypeEnum.trigger)
        .setSizes(AdSizes.mobile_Generic)
        .setIsAutoRefreshEnabled(true)
        .setIsPrebidEnabled(true)
        .setPrebidSizeLimits(AdSizes.prebid_300x250)
        .setBidderHelper(pageBidderHelper)
    //.onSlotRenderEnded(fixPageSkinCssClass)

    ,
    AdUnit.builder(AdUnitTypeEnum.banner)
        .setDeviceType(deviceUtil.DeviceTypeInfo.mobileDevices)
        .setSpecialUseCase(AdUnitSpecialUseCaseEnum.intext)
        .setSpecialUseCaseIndex(7)
        .setIsEnabled(true)
        .setAdUnitPath("/66738120/sozcu_body_intext_mobile")
        .setDivId("div-sozcu_m_body_intext_300x250_13")
        .setDivStyleAfterRequest('')
        .setLoadingStrategy(AdLoadingStrategyTypeEnum.trigger)
        .setSizes(AdSizes.mobile_Generic)
        .setIsAutoRefreshEnabled(true)
        .setIsPrebidEnabled(true)
        .setPrebidSizeLimits(AdSizes.prebid_300x250)
        .setBidderHelper(pageBidderHelper)
    //.onSlotRenderEnded(fixPageSkinCssClass)

    ,
    //#endregion

    //#region intext index 8
    AdUnit.builder(AdUnitTypeEnum.banner)
        .setDeviceType(deviceUtil.DeviceTypeInfo.mobileDevices)
        .setSpecialUseCase(AdUnitSpecialUseCaseEnum.intext)
        .setSpecialUseCaseIndex(8)
        .setIsEnabled(true)
        .setAdUnitPath("/66738120/sozcu_body_intext_mobile")
        .setDivId("div-sozcu_m_body_intext_300x250_14")
        .setDivStyleAfterRequest('')
        .setLoadingStrategy(AdLoadingStrategyTypeEnum.trigger)
        .setSizes(AdSizes.mobile_Generic)
        .setIsAutoRefreshEnabled(true)
        .setIsPrebidEnabled(true)
        .setPrebidSizeLimits(AdSizes.prebid_300x250)
        .setBidderHelper(pageBidderHelper)
    //.onSlotRenderEnded(fixPageSkinCssClass)

    ,
    AdUnit.builder(AdUnitTypeEnum.banner)
        .setDeviceType(deviceUtil.DeviceTypeInfo.mobileDevices)
        .setSpecialUseCase(AdUnitSpecialUseCaseEnum.intext)
        .setSpecialUseCaseIndex(8)
        .setIsEnabled(true)
        .setAdUnitPath("/66738120/sozcu_body_intext_mobile")
        .setDivId("div-sozcu_m_body_intext_300x250_15")
        .setDivStyleAfterRequest('')
        .setLoadingStrategy(AdLoadingStrategyTypeEnum.trigger)
        .setSizes(AdSizes.mobile_Generic)
        .setIsAutoRefreshEnabled(true)
        .setIsPrebidEnabled(true)
        .setPrebidSizeLimits(AdSizes.prebid_300x250)
        .setBidderHelper(pageBidderHelper)
    //.onSlotRenderEnded(fixPageSkinCssClass)

    ,
    //#endregion

    //#region intext index 9
    AdUnit.builder(AdUnitTypeEnum.banner)
        .setDeviceType(deviceUtil.DeviceTypeInfo.mobileDevices)
        .setSpecialUseCase(AdUnitSpecialUseCaseEnum.intext)
        .setSpecialUseCaseIndex(9)
        .setIsEnabled(true)
        .setAdUnitPath("/66738120/sozcu_body_intext_mobile")
        .setDivId("div-sozcu_m_body_intext_300x250_16")
        .setDivStyleAfterRequest('')
        .setLoadingStrategy(AdLoadingStrategyTypeEnum.trigger)
        .setSizes(AdSizes.mobile_Generic)
        .setIsAutoRefreshEnabled(true)
        .setIsPrebidEnabled(true)
        .setPrebidSizeLimits(AdSizes.prebid_300x250)
        .setBidderHelper(pageBidderHelper)
    //.onSlotRenderEnded(fixPageSkinCssClass)

    ,
    AdUnit.builder(AdUnitTypeEnum.banner)
        .setDeviceType(deviceUtil.DeviceTypeInfo.mobileDevices)
        .setSpecialUseCase(AdUnitSpecialUseCaseEnum.intext)
        .setSpecialUseCaseIndex(9)
        .setIsEnabled(true)
        .setAdUnitPath("/66738120/sozcu_body_intext_mobile")
        .setDivId("div-sozcu_m_body_intext_300x250_17")
        .setDivStyleAfterRequest('')
        .setLoadingStrategy(AdLoadingStrategyTypeEnum.trigger)
        .setSizes(AdSizes.mobile_Generic)
        .setIsAutoRefreshEnabled(true)
        .setIsPrebidEnabled(true)
        .setPrebidSizeLimits(AdSizes.prebid_300x250)
        .setBidderHelper(pageBidderHelper)
    //.onSlotRenderEnded(fixPageSkinCssClass)

    ,
    //#endregion


    //#region intext index 10
    AdUnit.builder(AdUnitTypeEnum.banner)
        .setDeviceType(deviceUtil.DeviceTypeInfo.mobileDevices)
        .setSpecialUseCase(AdUnitSpecialUseCaseEnum.intext)
        .setSpecialUseCaseIndex(10)
        .setIsEnabled(true)
        .setAdUnitPath("/66738120/sozcu_body_intext_mobile")
        .setDivId("div-sozcu_m_body_intext_300x250_18")
        .setDivStyleAfterRequest('')
        .setLoadingStrategy(AdLoadingStrategyTypeEnum.trigger)
        .setSizes(AdSizes.mobile_Generic)
        .setIsAutoRefreshEnabled(true)
        .setIsPrebidEnabled(true)
        .setPrebidSizeLimits(AdSizes.prebid_300x250)
        .setBidderHelper(pageBidderHelper)
    //.onSlotRenderEnded(fixPageSkinCssClass)

    ,
    AdUnit.builder(AdUnitTypeEnum.banner)
        .setDeviceType(deviceUtil.DeviceTypeInfo.mobileDevices)
        .setSpecialUseCase(AdUnitSpecialUseCaseEnum.intext)
        .setSpecialUseCaseIndex(10)
        .setIsEnabled(true)
        .setAdUnitPath("/66738120/sozcu_body_intext_mobile")
        .setDivId("div-sozcu_m_body_intext_300x250_19")
        .setDivStyleAfterRequest('')
        .setLoadingStrategy(AdLoadingStrategyTypeEnum.trigger)
        .setSizes(AdSizes.mobile_Generic)
        .setIsAutoRefreshEnabled(true)
        .setIsPrebidEnabled(true)
        .setPrebidSizeLimits(AdSizes.prebid_300x250)
        .setBidderHelper(pageBidderHelper)
    //.onSlotRenderEnded(fixPageSkinCssClass)

    ,
    //#endregion


]